import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'exg-option',
  templateUrl: './exg-option.component.html'
})
export class ExgOptionComponent implements OnInit {

  @Input() disabled!: string;
  @Input() list = [];
  @Input() listdisplay!: string;
  @Input() caption!: string;
  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  id = Math.random().toString(36).substring(2);

  constructor() {
  }

  ngOnInit(): void {
  }


  public displayItem(item: any): any {
    if (this.listdisplay) {
      if (item) {
        return item[this.listdisplay];
      } else {
        return null;
      }
    } else {
      if (item) {
        return item;
      } else {
        return null;
      }
    }
  }

  change(newValue: any): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

}
